import { Img } from "components/Img";
import BrandingActionCard from "./BrandingActionCard";

const BrandingViewCard = ({ element, handleOpenDrawer, handleOptionChange, subChildren, addMore, isError, onDelete }) => {
  // const [element?.hasMaterials, setHasMaterials] = useState(true);

  // const handleOptionChange = (value) => {
  //   setHasMaterials(value);
  // };

  return (
    <div className="col-span-12 my-4">
      <div className="grid grid-cols-12 gap-4 w-full p-4 bg-[#F5F5F5] rounded-2xl">
        <div className="col-span-4 bg-white rounded-lg shadow-lg p-6 flex flex-col items-center justify-center w-[90%] max-w-md gap-4">
          {/* Brand Icon */}
          <div className="mb-2">
            <div className="relative">
              <Img src="/images/Branding.svg" alt="brand frame" className="w-[14vh] h-[14vh]" />
            </div>
          </div>

          {/* Question Text */}
          <div className="text-[2vh] text-center font-manropeB">Have Materials Already?</div>

          {/* Radio Options */}
          <div className="flex flex-col items-center justify-center w-full gap-2">
            <label className="flex items-center cursor-pointer">
              <div className={`w-[2vh] h-[2vh] rounded-full border flex items-center justify-center ${element?.hasMaterials ? 'border-indigo-600' : 'border-gray-300'}`}>
                {element?.hasMaterials && (
                  <div className="w-[1vh] h-[1vh] bg-indigo-600 rounded-full"></div>
                )}
              </div>
              <input
                type="radio"
                className="hidden"
                checked={element?.hasMaterials}
                onChange={() => handleOptionChange(true)}
              />
              <span className="ml-2 text-[2vh]">Yes, we do</span>
            </label>

            <label className="flex items-center cursor-pointer">
              <div className={`w-[2vh] h-[2vh] rounded-full border flex items-center justify-center ${!element?.hasMaterials ? 'border-indigo-600' : 'border-gray-300'}`}>
                {!element?.hasMaterials && (
                  <div className="w-[1vh] h-[1vh] bg-indigo-600 rounded-full"></div>
                )}
              </div>
              <input
                type="radio"
                className="hidden"
                checked={!element?.hasMaterials}
                onChange={() => handleOptionChange(false)}
              />
              <span className="ml-2 text-[2vh]">No, design my material</span>
            </label>
          </div>
        </div>
        {!element?.hasMaterials ? <></> : <div className="col-span-8 space-y-2">
          <div className="col-span-12 flex justify-between items-center">
            <h1 className="text-[3vh] font-manropeB">Add Brand Marketing Material</h1>
           {!!element?.SAVED && <button
              onClick={addMore}
              type="button"
              style={{ color: '#fff' }}
              className={`inline-flex items-center px-4 py-2 text-[1.8vh] font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 focus:outline-none`}
            >
              Upload Material
            </button>}
          </div>
          <div className="col-span-12 mt-2">
            {!!element?.SAVED ? <BrandingActionCard isError={isError} element={element} handleOpenDrawer={handleOpenDrawer} onDelete={onDelete} /> : subChildren}
          </div>
        </div>}
      </div>
    </div>
  );
};

export default BrandingViewCard;